<template>
  <div>
    <Table :loading="loading"
           :border="showBorder"
           :stripe="showStripe"
           :show-header="showHeader"
           :height="fixedHeader ? 250 : ''"
           :size="tableSize"
           :data="tableData"
           :columns="tableColumns"
           :highlight-row="highlightRow"
           tooltip-theme="dark"
           ref="selection"
           :show-footer="showFooter">

      <template slot-scope="{ row }"
                slot="action">
        <Button type="primary"
                size="small"
                style="margin-right: 5px"
                @click="edit(row)">编辑</Button>
        <Button type="error"
                size="small"
                style="margin-right: 5px"
                @click="del(row)"
                v-if='row.lv<9'>删除</Button>
      </template>

    </Table>

  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: [],
      stateFilter: [
        { label: '激活', value: '1' },
        { label: '未激活', value: '0' }
      ],
      showBorder: true, // 显示表格列边框
      showStripe: true, // 显示斑马线样式
      showHeader: true, // 显示b表头
      showIndex: true, // 显示索引序号
      showExpand: false, // 显示简要介绍
      showCheckbox: false, // 显示复选框
      fixedHeader: false, // 固定表头
      highlightRow: true, // 高亮选择的行

      loading: false,
      // tooltip: true,
      tableSize: 'small',
      showFooter: true,
      fromPage: 1,
      rowNums: 10,
      infoTotal: 0
    };
  },
  computed: {
    curpage () {
      return this.fromPage;
    },
    tableColumns () {
      let columns = [];
      if (this.showCheckbox) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      if (this.showIndex) {
        columns.push({
          type: 'index',
          width: 60,
          align: 'center'
        });
      }
      if (this.showExpand) {
        columns.push({
          type: 'expand',
          width: 60,
          align: 'center'
        });
      }
      columns.push({
        title: '姓名',
        key: 'userName',
        width: 130,
        align: 'left'
      });
      columns.push({
        title: '最后一次登录时间',
        key: 'last_login_time',
        sortable: false,
        width: 'auto',
        align: 'center'
      });
      columns.push({
        title: '联系电话',
        key: 'phone',
        align: 'center',
        width: 150
      });
      columns.push({
        title: '用户状态',
        key: 'state',
        sortable: false,
        width: 120,
        align: 'center',
        filterMultiple: false,
        filters: this.stateFilter,
        filterMethod (value, row) {
          console.log(row);
          return row.state === value;
        }
      });

      columns.push({
        title: '用户名（工号)',
        key: 'userId',
        sortable: false,
        width: 120,
        align: 'center'
      });
      columns.push({
        title: '性别',
        key: 'gender',
        sortable: false,
        width: 120,
        align: 'center'
      });

      columns.push({
        title: '操作',
        slot: 'action',
        width: 150,
        align: 'center'
      });

      return columns;
    }
  },
  created () {},
  mounted () {
    this.getInfos(this.fromPage, this.rowNums);
  },
  methods: {
    getInfos (fromPage, rowNums) {
      this.loading = true;
      this.$axios
        .request({
          url:
            'caiji/?s=user.getUserList&from=' + fromPage + '&nums=' + rowNums,
          method: 'GET'
        })
        .then(json => {
          console.log('用户列表数据：', json);
          this.tableData = json.data.data;
          this.loading = false;
        });
    },

    edit (row) {
      console.log('row', row);
      this.$router.push({
        name: 'useredit',
        params: {
          id: row.id,
          userId: row.userId
        }
      });
    },
    del (row) {
      console.log('delrow', row);
      this.$Modal.confirm({
        title: '提示:',
        content:
          '<p>您确定要删除<strong style="color:red">' +
          row.userName +
          '</strong>吗?</p>',

        onOk: () => {
          this.$axios
            .request({
              url: 'caiji/?s=user.delUser&id=' + row.id,
              method: 'GET'
            })
            .then(json => {
              console.log('删除结果：', json);
              this.$Modal.remove();
              this.$Message.info(' 成功删除了!');
              this.getInfos(this.fromPage, this.rowNums);
            });
        }
      });
    }
  }
};
</script>
